import * as React from "react";
import * as _ from "lodash";
import * as moment from "moment";
import { connect, Dispatch } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import {
    IApplicationState, AppActionCreators,
    IRccapState, RccapActionCreators, IRccapLookupDataResponse, IRccapResponse, ILookupData,
    IRccapAdminResponse, IRccapPositionDetailResponse,
    SwapActionCreators
} from "@nkr/store/index";
import { bloodTypes, IRccapRequest, IRccapAdditionalQuestionWithValidation } from "@nkr/models/index";
import { NkrContactPosition, RccapStatus } from "@nkr/enums/index";
import { Button, Row, Col, FormControl, Panel, FormGroup, ControlLabel, Alert, Badge, Sizes } from "react-bootstrap";
import AdditionalQuestions from "./rccap-additional-questions";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import * as queryString from "query-string";
import ActionButtons from "./action-buttons";
import MaskedInput from "react-maskedinput";
import * as DateTimeModule from "react-datetime";

const DateTime = (DateTimeModule as any).default;

interface IValidation {
    recipientAlias: boolean,
    matchOfferDate: boolean,
    failDate: boolean,
    targetSurgeryDate: boolean,
    donorAlias: boolean,
    dueDate: boolean,
    swapChainNumber: boolean,
    swapClusterNumber: boolean,
    swapPositionNumber: boolean,
    transplantsImpacted: boolean,
    whatHappened: boolean,
    additionalQuestions: boolean
}

interface IProps extends RouteComponentProps<{ id: string }> { };

interface IStateProps {
    rccap: IRccapState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getLookupData: () => Promise<IRccapLookupDataResponse>,
    setLookupData: (lookupData: ILookupData) => void,
    getRccap: (id: number) => Promise<IRccapResponse>,
    saveRccap: (request: IRccapRequest) => Promise<IRccapAdminResponse>,
    getRccapDetails: (chainId: number, clusterNumber: number, positionNumber: number) => Promise<IRccapPositionDetailResponse>
}

type TProps =
    IProps
    & IStateProps
    & IDispatchProps;

interface IState {
    id: number,
    swapChainNumber: string,
    swapClusterNumber: string,
    swapPositionNumber: string,
    donorCenterId: number,
    donorAlias: string,
    rccapManagerId: number,
    recipientAlias: string,
    recipientAbo: string,
    pairedDonorAbo: string,
    recipientPmpC: string,
    recipientCpra: string,
    recipientCenterId: number,
    responsibleCenterId: number,
    rccapRequesterId: number,
    failDate: string,
    nkrLiaison: number,
    dueDate: string,
    transplantsImpacted: string,
    surgeriesImpacted: number,
    matchOfferDate: string
    exmRequestDate: string,
    rccapPhase: number,
    whatHappened: string,
    originalAdditionalQuestions: string,
    additionalQuestions: IRccapAdditionalQuestionWithValidation[],
    rootCausePrimaryId: number,
    rootCauseSecondaryId: number,
    rccapAvoidable: number,
    rccapBillable: number,
    rccapSatisfactoryResponse: number,
    acceptedResponse: string,
    correctiveActionPrimary: number,
    correctiveActionSecondary: number,
    centerCorrectiveAction: string,
    responder: string,
    responseDate: string,
    targetSurgeryDate: string,
    validation: IValidation,
    loadSwap: boolean,
    origin: string,
    dirty: boolean
}

class RccapAddEdit extends React.Component<TProps, IState> {
    readonly state: IState = {
        id: 0,
        swapChainNumber: "",
        swapClusterNumber: "",
        swapPositionNumber: "",
        donorCenterId: 0,
        donorAlias: "",
        rccapManagerId: 0,
        recipientAlias: "",
        recipientAbo: "",
        pairedDonorAbo: "",
        recipientPmpC: "",
        recipientCpra: "",
        recipientCenterId: 0,
        responsibleCenterId: 0,
        rccapRequesterId: 0,
        failDate: moment().format("MM/DD/YY HH:mm"),
        nkrLiaison: 0,
        dueDate: moment().add(1, "d").format("MM/DD/YY 18:00"),
        transplantsImpacted: "",
        surgeriesImpacted: 0,
        matchOfferDate: "",
        exmRequestDate: "",
        rccapPhase: 0,
        whatHappened: "",
        originalAdditionalQuestions: "",
        additionalQuestions: [],
        rootCausePrimaryId: 0,
        rootCauseSecondaryId: 0,
        rccapAvoidable: 0,
        rccapBillable: 0,
        rccapSatisfactoryResponse: 0,
        acceptedResponse: "",
        correctiveActionPrimary: 0,
        correctiveActionSecondary: 0,
        centerCorrectiveAction: "",
        responder: "",
        responseDate: "",
        targetSurgeryDate: "",
        validation: {
            recipientAlias: true,
            matchOfferDate: true,
            failDate: true,
            targetSurgeryDate: true,
            donorAlias: true,
            dueDate: true,
            swapChainNumber: true,
            swapClusterNumber: true,
            swapPositionNumber: true,
            transplantsImpacted: true,
            whatHappened: true,
            additionalQuestions: true
        },
        loadSwap: false,
        origin: "",
        dirty: false
    }

    componentDidMount = () => {
        this.getData();
    }

    handleTextChange = (e: React.FormEvent<HTMLInputElement & FormControl>) => {
        let { name, value } = e.currentTarget;
        let validation = { ...this.state.validation };

        if (this.state.dirty)
            validation[name] = value != "";

        if (name == "transplantsImpacted")
            this.updateData(name, parseInt(value), validation);
        else
            this.updateData(name, value, validation);
    }

    handleSelectChange = (e: React.FormEvent<HTMLSelectElement & FormControl>) => {
        let { name, value } = e.currentTarget;
        let validation = { ...this.state.validation };

        if (name == "recipientAbo" || name == "pairedDonorAbo")
            this.updateData(name, value, validation);
        else
            this.updateData(name, parseInt(value), validation);
    }

    handleDateChange = (name: string, e: moment.Moment) => {
        let validation = { ...this.state.validation };

        if (this.state.dirty)
            validation[name] = typeof e != "string";

        this.updateData(name, e.format("MM/DD/YY"), validation);
    }

    handleResponseDateChange = (e: React.FormEvent<HTMLInputElement>) => {
        this.setState({
            responseDate: e.currentTarget.value
        });
    }

    handleLoadSwap = () => {
        let { swapChainNumber, swapClusterNumber, swapPositionNumber } = this.state;
        let chainId = parseInt(swapChainNumber);
        let clusterNumber = parseInt(swapClusterNumber);
        let positionNumber = parseInt(swapPositionNumber);

        let validation = { ...this.state.validation, swapChainNumber: !isNaN(chainId), swapClusterNumber: !isNaN(clusterNumber), swapPositionNumber: !isNaN(positionNumber) };
        let isValid = validation.swapChainNumber && validation.swapClusterNumber && validation.swapPositionNumber;

        this.setState({
            validation,
            loadSwap: true
        }, () => {
            if (isValid) {
                this.props.showLoading("Retrieving swap information, one moment please...").then(() => {
                    this.props.getRccapDetails(chainId, clusterNumber, positionNumber).then(response => {
                        this.props.hideLoading();

                        if (response.data.success) {
                            let {
                                donorAlias, donorCenterId,
                                transplantsImpacted, matchOfferDate, exmRequestedDate: exmRequestDate, rccapPhase,
                                recipientAlias, recipientCenterId, recipientAbo, recipientDonorAbo: pairedDonorAbo, recipientPmpC, recipientCpra,
                                matchHistoryRejectionReasonText: whatHappened,
                                matchHistoryCorrectiveAction: centerCorrectiveAction,
                                matchHistorySignOff: responder, responseDate
                            } = response.data.results;

                            this.setState({
                                donorAlias,
                                donorCenterId,
                                transplantsImpacted: transplantsImpacted.toString(),
                                matchOfferDate,
                                exmRequestDate,
                                rccapPhase,
                                recipientAlias,
                                recipientCenterId,
                                recipientAbo,
                                pairedDonorAbo,
                                recipientCpra: recipientCpra.toString(),
                                recipientPmpC: recipientPmpC.toString(),
                                whatHappened,
                                centerCorrectiveAction,
                                responder,
                                responseDate: responseDate != null ? moment(responseDate).format("MM/DD/YY HH:mm") : moment().format("MM/DD/YY HH:mm"),
                            }, () => {
                                validation = this.validate();

                                this.setState({
                                    validation
                                });
                            });
                        }
                    });
                });
            }
        });
    }

    handleChangeQuestion = (question: string, index: number) => {
        let additionalQuestions = _.cloneDeep(this.state.additionalQuestions);
        additionalQuestions[index].question = question;

        if (this.state.dirty)
            additionalQuestions[index].isValid = question != "";

        this.setState({
            additionalQuestions
        });
    }

    handleChangeAnswer = (answer: string, index: number) => {
        let additionalQuestions = _.cloneDeep(this.state.additionalQuestions);
        additionalQuestions[index].answer = answer;

        this.setState({
            additionalQuestions
        });
    }

    handleRemoveQuestion = (index: number) => {
        let additionalQuestions = this.state.additionalQuestions.map((q, itemIndex) => {
            if (index == itemIndex)
                q.isDeleted = true;

            return q;
        });

        let validation = this.state.validation;

        if (this.state.dirty)
            validation.additionalQuestions = additionalQuestions.length > 0;

        this.setState({
            additionalQuestions,
            validation
        });
    }

    handleAddQuestion = () => {
        let additionalQuestions = [...this.state.additionalQuestions];
        additionalQuestions.push({ id: -1, question: "", answer: "", isValid: true, isDeleted: false });

        let validation = this.state.validation;

        if (this.state.dirty)
            validation.additionalQuestions = additionalQuestions.length > 0;

        this.setState({
            additionalQuestions,
            validation
        });
    }

    handleSave = (currentStatus: RccapStatus, sendEmail: boolean) => {
        let validation = this.validate();

        let additionalQuestions = this.state.additionalQuestions.map(q => {
            q.isValid = q.question != "";
            return q;
        });

        this.setState({
            additionalQuestions,
            validation,
            loadSwap: false,
            dirty: true
        }, () => {
            let isValid = this.isValid();
            let emailResponses = [RccapStatus.PendingResponse, RccapStatus.NeedsMoreInfo, RccapStatus.Accepted];

            if (currentStatus == RccapStatus.Draft || (emailResponses.includes(currentStatus) && isValid)) {
                let {
                    id, swapChainNumber, swapClusterNumber, swapPositionNumber, donorCenterId, donorAlias, rccapManagerId,
                    recipientCenterId, recipientAlias, recipientAbo, pairedDonorAbo, recipientPmpC, recipientCpra, responsibleCenterId,
                    rccapRequesterId, failDate, dueDate, transplantsImpacted, matchOfferDate, exmRequestDate,
                    rccapPhase, whatHappened, additionalQuestions, rootCausePrimaryId, rootCauseSecondaryId, rccapAvoidable, rccapBillable, rccapSatisfactoryResponse,
                    acceptedResponse, correctiveActionPrimary, correctiveActionSecondary, centerCorrectiveAction, responder, responseDate, targetSurgeryDate
                } = this.state;

                let request: IRccapRequest = {
                    id,
                    currentStatus,
                    responsibleCenterId,
                    recipientCenterId,
                    recipientAlias,
                    recipientPmpc: recipientPmpC,
                    recipientCpra,
                    recipientAbo,
                    recipientsDonorAbo: pairedDonorAbo,
                    matchOfferDate,
                    exmRequestDate,
                    failDate,
                    targetSurgeryDate,
                    dueDate,
                    responseDate,
                    donorCenterId,
                    donorAlias,
                    rccapManagerId,
                    rccapRequesterId,
                    swapChainNumber: swapChainNumber != "" ? parseInt(swapChainNumber) : null,
                    swapClusterNumber: swapClusterNumber != "" ? parseInt(swapClusterNumber) : null,
                    swapPositionNumber: swapPositionNumber != "" ? parseInt(swapPositionNumber) : null,
                    transplantsImpacted: transplantsImpacted != "" ? parseInt(transplantsImpacted) : null,
                    whatHappened,
                    additionalQuestions,
                    rootCausePrimaryId,
                    rootCauseSecondaryId,
                    rootCauseInfo: acceptedResponse,
                    rootCauseAdditional: "",
                    avoidable: rccapAvoidable,
                    billable: rccapBillable,
                    phase: rccapPhase,
                    correctiveActionPrimary,
                    correctiveActionSecondary,
                    correctiveActionInfo: centerCorrectiveAction,
                    correctiveActionAdditional: "",
                    responder,
                    shortAdminCorrectiveAction: "",
                    shortAdminRootCause: "",
                    additionalComments: "",
                    satisfactoryResponse: rccapSatisfactoryResponse,
                    sendEmail
                }

                this.props.showLoading("Saving RCCAP info, one moment please...").then(() => {
                    this.props.saveRccap(request).then(response => {
                        this.props.hideLoading();

                        if (response.data.success) {
                            this.setState({
                                id: response.data.results
                            }, () => {
                                toast.success("Successfully save RCCAP...");
                            });
                        }
                    });
                });
            } else {
                window.scrollTo(0, 0);
            }
        });
    }

    handleCancel = () => {
        if (this.state.origin == '')
            window.location.href = '/admin/rccap';
        else
            window.location.href = '/admin/report/rccap-detail';
    }

    private isValid = (): boolean => {
        let validation = this.state.validation;
        let additionalQuestionsValid = this.state.additionalQuestions.filter(q => q.isValid == false && q.isDeleted == false).length == 0;

        let isValid =
            validation.recipientAlias && validation.matchOfferDate && validation.failDate && validation.targetSurgeryDate
            && validation.donorAlias && validation.dueDate && validation.swapChainNumber && validation.swapClusterNumber && validation.swapPositionNumber
            && validation.transplantsImpacted && validation.whatHappened && validation.additionalQuestions;

        return isValid && additionalQuestionsValid;
    }

    private isNumeric = (n: any) => {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    private validate = () => {
        let { recipientAlias, matchOfferDate, failDate, targetSurgeryDate,
            donorAlias, dueDate, swapChainNumber, swapClusterNumber, swapPositionNumber,
            transplantsImpacted, whatHappened, additionalQuestions } = this.state;

        let validation: IValidation = {
            recipientAlias: recipientAlias != "",
            matchOfferDate: matchOfferDate != "" && moment(matchOfferDate).isValid(),
            failDate: failDate != "" && moment(failDate).isValid(),
            targetSurgeryDate: targetSurgeryDate != "" && moment(targetSurgeryDate).isValid(),
            donorAlias: donorAlias != "",
            dueDate: dueDate != "" && moment(dueDate).isValid(),
            swapChainNumber: swapChainNumber != "" && this.isNumeric(swapChainNumber),
            swapClusterNumber: swapClusterNumber != "" && this.isNumeric(swapClusterNumber),
            swapPositionNumber: swapPositionNumber != "" && this.isNumeric(swapPositionNumber),
            transplantsImpacted: transplantsImpacted != "" && this.isNumeric(transplantsImpacted),
            whatHappened: whatHappened != "",
            additionalQuestions: true
        };

        return validation;
    }

    private updateData = (property: string, value: string | number, validation: IValidation) => {
        let state = { ...this.state, [property]: value, validation };

        this.setState(state);
    }

    private getData = () => {
        let { id } = this.props.match.params;
        let values = queryString.parse(this.props.location.search);
        let origin = values.origin != undefined ? values.origin : '';

        if (parseInt(id) > 0) {
            this.props.showLoading("Getting RCCAP info, one moment please...").then(() => {
                Promise.all([
                    this.props.getRccap(parseInt(id)),
                    this.props.getLookupData()
                ])
                    .then((response: [IRccapResponse, IRccapLookupDataResponse]) => {
                        this.props.hideLoading();

                        let rccapResponse = response[0];
                        let rccap = rccapResponse.data.results;
                        let rccapLookupDataResponse = response[1];
                        let lookupData = rccapLookupDataResponse.data.results;

                        if (!rccap) {
                            let rootCause = lookupData.causes[0];
                            let secondaryCauseList = rootCause.secondaryCauses;

                            this.setState({
                                ...this.state,
                                donorCenterId: lookupData.centers[0].id,
                                rccapManagerId: lookupData.staffList[0].id,
                                recipientAbo: bloodTypes[0],
                                pairedDonorAbo: bloodTypes[0],
                                recipientCenterId: lookupData.centers[0].id,
                                responsibleCenterId: rccap.responsibleCenterId,
                                rccapRequesterId: lookupData.staffList[0].id,
                                rootCausePrimaryId: rootCause.id,
                                rootCauseSecondaryId: secondaryCauseList[0].id,
                                rccapAvoidable: lookupData.avoidable[0].id,
                                rccapBillable: lookupData.billable[0].id,
                                rccapSatisfactoryResponse: lookupData.satisfactoryResponses[0].id,
                                origin
                            }, () => {
                                this.props.setLookupData(lookupData);
                            });
                        } else {
                            let {
                                id,
                                swapChainNumber, swapClusterNumber, swapPositionNumber,
                                donorAlias, donorCenterId, rccapManagerId, targetSurgeryDate,
                                recipientAlias, recipientAbo, recipientsDonorAbo, recipientPmpc, recipientCpra, recipientCenterId,
                                responsibleCenterId, rccapRequesterId,
                                failDate, dueDate, transplantsImpacted, matchOfferDate, exmRequestDate,
                                phase, whatHappened, rootCausePrimaryId, rootCauseSecondaryId,
                                avoidable, billable, satisfactoryResponse, rootCauseInfo,
                                correctiveActionPrimary, correctiveActionSecondary, correctiveActionInfo,
                                responder, responseDate, additionalQuestions: additionalQuestionList, originalAdditionalQuestions
                            } = rccap;

                            let additionalQuestions = additionalQuestionList.map(q => {
                                let question: IRccapAdditionalQuestionWithValidation = {
                                    id: q.id,
                                    question: q.question,
                                    answer: q.answer,
                                    isValid: true,
                                    isDeleted: false
                                };

                                return question;
                            })

                            this.setState({
                                id,
                                swapChainNumber: swapChainNumber != null ? swapChainNumber.toString() : '',
                                swapClusterNumber: swapClusterNumber != null ? swapClusterNumber.toString() : '',
                                swapPositionNumber: swapPositionNumber != null ? swapPositionNumber.toString() : '',
                                donorCenterId,
                                donorAlias,
                                rccapManagerId,
                                targetSurgeryDate,
                                recipientAlias,
                                recipientAbo,
                                pairedDonorAbo: recipientsDonorAbo,
                                recipientPmpC: recipientPmpc,
                                recipientCpra,
                                recipientCenterId,
                                responsibleCenterId,
                                rccapRequesterId,
                                failDate,
                                nkrLiaison: 0,
                                dueDate,
                                transplantsImpacted: transplantsImpacted != null ? transplantsImpacted.toString() : '',
                                surgeriesImpacted: 0,
                                matchOfferDate,
                                exmRequestDate,
                                rccapPhase: phase,
                                whatHappened,
                                originalAdditionalQuestions,
                                additionalQuestions,
                                rootCausePrimaryId,
                                rootCauseSecondaryId,
                                rccapAvoidable: avoidable,
                                rccapBillable: billable,
                                rccapSatisfactoryResponse: satisfactoryResponse,
                                acceptedResponse: rootCauseInfo,
                                correctiveActionPrimary,
                                correctiveActionSecondary,
                                centerCorrectiveAction: correctiveActionInfo,
                                responder,
                                responseDate,
                                origin
                            }, () => {
                                this.props.setLookupData(lookupData);
                            });
                        }
                    });
            });
        } else {
            this.props.showLoading("Configuring RCCAP system, one moment please...").then(() => {
                this.props.getLookupData()
                    .then((response: IRccapLookupDataResponse) => {
                        this.props.hideLoading();

                        let lookupData = response.data.results;
                        let rootCause = lookupData.causes[0];
                        let secondaryCauseList = rootCause.secondaryCauses;

                        this.setState({
                            ...this.state,
                            donorCenterId: lookupData.centers[0].id,
                            rccapManagerId: lookupData.staffList[0].id,
                            recipientAbo: bloodTypes[0],
                            pairedDonorAbo: bloodTypes[0],
                            recipientCenterId: lookupData.centers[0].id,
                            responsibleCenterId: lookupData.centers[0].id,
                            rccapRequesterId: lookupData.staffList[0].id,
                            rootCausePrimaryId: rootCause.id,
                            rootCauseSecondaryId: secondaryCauseList[0].id,
                            rccapAvoidable: lookupData.avoidable[0].id,
                            rccapBillable: lookupData.billable[0].id,
                            rccapSatisfactoryResponse: lookupData.satisfactoryResponses[0].id,
                        }, () => {
                            this.props.setLookupData(lookupData);
                        });
                    })
                    .catch((error: AxiosError) => {
                        this.props.hideLoading();
                        toast.error('There was an issue while loading the RCCAP data...');
                    });
            });
        }
    }

    render = () => {
        const {
            id, swapChainNumber, swapClusterNumber, swapPositionNumber, donorCenterId, donorAlias, rccapManagerId,
            recipientCenterId, recipientAlias, recipientAbo, pairedDonorAbo, recipientPmpC, recipientCpra, responsibleCenterId,
            rccapRequesterId, failDate, dueDate, transplantsImpacted, matchOfferDate, exmRequestDate,
            rccapPhase, whatHappened, additionalQuestions, rootCausePrimaryId, rootCauseSecondaryId, rccapAvoidable, rccapBillable, rccapSatisfactoryResponse,
            acceptedResponse, correctiveActionPrimary, correctiveActionSecondary, centerCorrectiveAction, responder, responseDate, targetSurgeryDate,
            validation, loadSwap, dirty
        } = this.state;

        const defaultSecondaryCauses = this.props.rccap.lookupData.causes.length > 0 ? this.props.rccap.lookupData.causes[0].secondaryCauses : []
        const rootCause = this.props.rccap.lookupData.causes.find(c => c.id == rootCausePrimaryId);
        const secondaryCauseList = rootCause ? rootCause.secondaryCauses : defaultSecondaryCauses;

        const title = id > 0 ? "Edit RCCAP" : "Add RCCAP";

        const { swapChainNumber: schn, swapClusterNumber: scln, swapPositionNumber: spn } = validation;
        const loadSwapValid = schn && scln && spn;
        const isValid = this.isValid();

        const validationErrors = [
            loadSwapValid,
            validation.failDate,
            validation.targetSurgeryDate,
            validation.dueDate,
            validation.donorAlias,
            validation.transplantsImpacted,
            validation.matchOfferDate,
            validation.recipientAlias,
            validation.whatHappened,
            validation.additionalQuestions
        ];

        const validationList = [
            'Swap, Cluster, & Position',
            'Date Swap Failed',
            'Target Surgery Date',
            'Response Deadline',
            'Donor Alias',
            'Transplants Impacted',
            'Date Match Offered',
            'Recipient Alias',
            'What Happened?',
            'Additional Questions for the Responsible Center'
        ];

        var requesterList = _.sortBy(this.props.rccap.lookupData.staffList.filter(x => x.positions.filter(x => x.id == NkrContactPosition.Operations).length > 0), x => x.fullName);
        var liaisonList = _.sortBy(this.props.rccap.lookupData.staffList.filter(x => x.positions.filter(x => x.id == NkrContactPosition.NkrLiaison).length > 0), x => x.fullName);

        return (
            <div className="container" style={{ paddingBottom: 20 }}>
                {loadSwap && !loadSwapValid && (
                    <Row>
                        <Col>
                            <Alert bsStyle="danger">
                                To load a swap, please specify values for the Swap, Cluster, and Position...
                            </Alert>
                        </Col>
                    </Row>
                )}

                {dirty && !isValid && (
                    <Row>
                        <Col>
                            <Alert bsStyle="danger">
                                <div style={{ marginBottom: 5 }}>Please specify the following information:</div>
                                <ul>
                                    {validationList.map((item, index) => {
                                        if (validationErrors[index] == false)
                                            return (
                                                <li key={index}>{item}</li>
                                            );
                                    })}
                                </ul>
                            </Alert>
                        </Col>
                    </Row>
                )}

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 30, marginBottom: 40 }}>
                    <div style={{ width: '25%', fontSize: 28, fontWeight: 500 }}>
                        {title}
                    </div>
                    <ActionButtons size="small" onSave={this.handleSave} onCancel={this.handleCancel} />
                </div>

                <div className="container-fluid">
                    <Row style={{ marginBottom: 30 }}>
                        <Col xs={2} lg={2}>
                            <FormGroup validationState={this.state.validation.swapChainNumber ? null : "error"}>
                                <ControlLabel>Swap</ControlLabel>
                                <FormControl
                                    name="swapChainNumber"
                                    value={swapChainNumber}
                                    onChange={this.handleTextChange} />
                            </FormGroup>
                        </Col>
                        <Col xs={2} lg={2}>
                            <FormGroup validationState={this.state.validation.swapClusterNumber ? null : "error"}>
                                <ControlLabel>Cluster</ControlLabel>
                                <FormControl
                                    name="swapClusterNumber"
                                    value={swapClusterNumber}
                                    onChange={this.handleTextChange} />
                            </FormGroup>
                        </Col>
                        <Col xs={2} lg={2}>
                            <FormGroup validationState={this.state.validation.swapPositionNumber ? null : "error"}>
                                <ControlLabel>Position</ControlLabel>
                                <FormControl
                                    name="swapPositionNumber"
                                    value={swapPositionNumber}
                                    onChange={this.handleTextChange} />
                            </FormGroup>
                        </Col>
                        <Col xs={1} lg={1}>
                            <label>&nbsp;</label>
                            <Button type="submit" bsStyle="primary" onClick={this.handleLoadSwap}>Load Swap</Button>
                        </Col>
                        <Col xs={1} lg={5}>
                            <div className="pull-right">
                                <FormGroup>
                                    <ControlLabel>Responsible Center</ControlLabel>
                                    <FormControl
                                        componentClass="select"
                                        name="responsibleCenterId"
                                        value={responsibleCenterId}
                                        style={{ width: "initial" }}
                                        onChange={this.handleSelectChange}
                                    >
                                        {this.props.rccap.lookupData.centers.map((center, index) =>
                                            <option key={index} value={center.id}>{center.alias}</option>
                                        )}
                                    </FormControl>
                                </FormGroup>
                            </div>
                        </Col>
                    </Row>

                    <Row style={{ marginBottom: 10 }}>
                        <Col xs={6} lg={6}>
                            <div>
                                <FormGroup>
                                    <ControlLabel>RCCAP Requester</ControlLabel>
                                    <FormControl
                                        componentClass="select"
                                        name="rccapRequesterId"
                                        value={rccapRequesterId}
                                        onChange={this.handleSelectChange}
                                    >
                                        {requesterList.map((item, index) =>
                                            <option key={index} value={item.id}>{item.fullName}</option>
                                        )}
                                    </FormControl>
                                </FormGroup>
                            </div>

                            <div>
                                <FormGroup>
                                    <ControlLabel>NKR Liaison</ControlLabel>
                                    <FormControl
                                        componentClass="select"
                                        name="rccapManagerId"
                                        value={rccapManagerId}
                                        onChange={this.handleSelectChange}
                                    >
                                        {liaisonList.map((item, index) =>
                                            <option key={index} value={item.id}>{item.fullName}</option>
                                        )}
                                    </FormControl>
                                </FormGroup>
                            </div>
                        </Col>
                        <Col xs={6} lg={6}>
                            <div>
                                <FormGroup validationState={this.state.validation.failDate ? null : "error"}>
                                    <ControlLabel>Date Swap Failed</ControlLabel>
                                    <div>
                                        <DateTime
                                            value={failDate}
                                            input={true}
                                            dateFormat={"MM/DD/YY"}
                                            timeFormat={false}
                                            closeOnSelect={false}
                                            inputProps={{ className: "form-control" }}
                                            onChange={(value: moment.Moment) => this.handleDateChange('failDate', value)}
                                        />
                                    </div>
                                </FormGroup>
                            </div>

                            <div>
                                <FormGroup validationState={this.state.validation.targetSurgeryDate ? null : "error"}>
                                    <ControlLabel>Target Surgery Date</ControlLabel>
                                    <div>
                                        <DateTime
                                            value={targetSurgeryDate}
                                            input={true}
                                            dateFormat={"MM/DD/YY"}
                                            timeFormat={false}
                                            closeOnSelect={false}
                                            inputProps={{ className: "form-control" }}
                                            onChange={(value: moment.Moment) => this.handleDateChange('targetSurgeryDate', value)}
                                        />
                                    </div>
                                </FormGroup>
                            </div>

                            <div>
                                <FormGroup validationState={this.state.validation.dueDate ? null : "error"}>
                                    <ControlLabel>Response Deadline</ControlLabel>
                                    <div>
                                        <DateTime
                                            value={dueDate}
                                            input={true}
                                            dateFormat={"MM/DD/YY"}
                                            timeFormat={false}
                                            closeOnSelect={false}
                                            inputProps={{ className: "form-control" }}
                                            onChange={(value: moment.Moment) => this.handleDateChange('dueDate', value)}
                                        />
                                    </div>
                                </FormGroup>
                            </div>
                        </Col>
                    </Row>


                    <Panel>
                        <Panel.Heading>Position Details</Panel.Heading>
                        <Panel.Body>
                            <Row>
                                <Col xs={6} lg={6}>
                                    <div>
                                        <FormGroup>
                                            <ControlLabel>Donor Center</ControlLabel>
                                            <FormControl
                                                componentClass="select"
                                                name="donorCenterId"
                                                value={donorCenterId}
                                                onChange={this.handleSelectChange}
                                            >
                                                {this.props.rccap.lookupData.centers.map((item, index) =>
                                                    <option key={index} value={item.id}>{item.alias}</option>
                                                )}
                                            </FormControl>
                                        </FormGroup>
                                    </div>

                                    <div>
                                        <FormGroup validationState={this.state.validation.donorAlias ? null : "error"}>
                                            <ControlLabel>Donor Alias</ControlLabel>
                                            <FormControl
                                                name="donorAlias"
                                                value={donorAlias}
                                                onChange={this.handleTextChange}
                                            />
                                        </FormGroup>
                                    </div>

                                    <div>
                                        <FormGroup validationState={this.state.validation.transplantsImpacted ? null : "error"}>
                                            <ControlLabel>Transplants Impacted</ControlLabel>
                                            <FormControl
                                                name="transplantsImpacted"
                                                value={transplantsImpacted}
                                                onChange={this.handleTextChange}
                                            />
                                        </FormGroup>
                                    </div>

                                    <div>
                                        <FormGroup validationState={this.state.validation.matchOfferDate ? null : "error"}>
                                            <ControlLabel>Date Match Offered</ControlLabel>
                                            <div>
                                                <DateTime
                                                    value={matchOfferDate}
                                                    input={true}
                                                    dateFormat={"MM/DD/YY"}
                                                    timeFormat={false}
                                                    closeOnSelect={false}
                                                    inputProps={{ className: "form-control" }}
                                                    onChange={(value: moment.Moment) => this.handleDateChange('matchOfferDate', value)}
                                                />
                                            </div>
                                        </FormGroup>
                                    </div>

                                    <div>
                                        <FormGroup>
                                            <ControlLabel>Date EXM Requested</ControlLabel>
                                            <div>
                                                <DateTime
                                                    value={exmRequestDate}
                                                    input={true}
                                                    dateFormat={"MM/DD/YY"}
                                                    timeFormat={false}
                                                    closeOnSelect={false}
                                                    inputProps={{ className: "form-control" }}
                                                    onChange={(value: moment.Moment) => this.handleDateChange('exmRequestDate', value)}
                                                />
                                            </div>
                                        </FormGroup>
                                    </div>

                                    <div>
                                        <FormGroup>
                                            <ControlLabel>Phase</ControlLabel>
                                            <FormControl
                                                componentClass="select"
                                                name="rccapPhase"
                                                value={rccapPhase}
                                                onChange={this.handleSelectChange}
                                            >
                                                {this.props.rccap.lookupData.phases.map((phase, index) =>
                                                    <option key={index} value={phase.id}>{phase.description}</option>
                                                )}
                                            </FormControl>
                                        </FormGroup>
                                    </div>
                                </Col>
                                <Col xs={6} lg={6}>
                                    <div>
                                        <FormGroup>
                                            <ControlLabel>Recipient Center</ControlLabel>
                                            <FormControl
                                                componentClass="select"
                                                name="recipientCenterId"
                                                value={recipientCenterId}
                                                onChange={this.handleSelectChange}
                                            >
                                                {this.props.rccap.lookupData.centers.map((item, index) =>
                                                    <option key={index} value={item.id}>{item.alias}</option>
                                                )}
                                            </FormControl>
                                        </FormGroup>
                                    </div>

                                    <div>
                                        <FormGroup validationState={this.state.validation.recipientAlias ? null : "error"}>
                                            <ControlLabel>Recipient Alias</ControlLabel>
                                            <FormControl
                                                name="recipientAlias"
                                                value={recipientAlias}
                                                onChange={this.handleTextChange}
                                            />
                                        </FormGroup>
                                    </div>

                                    <div>
                                        <FormGroup>
                                            <ControlLabel>Recipient ABO</ControlLabel>
                                            <FormControl
                                                componentClass="select"
                                                name="recipientAbo"
                                                value={recipientAbo}
                                                onChange={this.handleSelectChange}
                                            >
                                                {bloodTypes.map((type, index) =>
                                                    <option key={index} value={type}>{type}</option>
                                                )}
                                            </FormControl>
                                        </FormGroup>
                                    </div>

                                    <div>
                                        <FormGroup>
                                            <ControlLabel>Paired Donor ABO</ControlLabel>
                                            <FormControl
                                                componentClass="select"
                                                name="pairedDonorAbo"
                                                value={pairedDonorAbo}
                                                onChange={this.handleSelectChange}
                                            >
                                                {bloodTypes.map((type, index) =>
                                                    <option key={index} value={type}>{type}</option>
                                                )}
                                            </FormControl>
                                        </FormGroup>
                                    </div>

                                    <div>
                                        <FormGroup>
                                            <ControlLabel>PMPc</ControlLabel>
                                            <FormControl
                                                name="recipientPmpC"
                                                value={recipientPmpC}
                                                onChange={this.handleTextChange}
                                            />
                                        </FormGroup>
                                    </div>

                                    <div>
                                        <FormGroup>
                                            <ControlLabel>NKR cPRA</ControlLabel>
                                            <FormControl
                                                name="recipientCpra"
                                                value={recipientCpra}
                                                onChange={this.handleTextChange}
                                            />
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        </Panel.Body>
                    </Panel>

                    <Row>
                        <Col xs={12} lg={12}>
                            <Panel>
                                <Panel.Heading><b>What Happened?</b></Panel.Heading>
                                <Panel.Body>
                                    <FormGroup validationState={this.state.validation.whatHappened ? null : "error"}>
                                        <FormControl
                                            componentClass="textarea"
                                            name="whatHappened"
                                            value={whatHappened}
                                            placeholder="Description of the issue..."
                                            style={{ height: 80, resize: "none" }}
                                            onChange={this.handleTextChange}
                                        />
                                    </FormGroup>
                                </Panel.Body>
                            </Panel>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={12}>
                            <Panel>
                                <Panel.Heading><b>Additional Questions for the Responsible Center</b></Panel.Heading>
                                <Panel.Body style={{ border: this.state.validation.additionalQuestions ? "0 none" : "1px solid #a94442", borderBottomLeftRadius: this.state.validation.additionalQuestions ? 0 : 4, borderBottomRightRadius: this.state.validation.additionalQuestions ? 0 : 4 }}>
                                    {this.state.originalAdditionalQuestions && (
                                        <Alert style={{ padding: "5px 7.5px" }}>
                                            <h4>Original Questions</h4>
                                            <p>{this.state.originalAdditionalQuestions.split('\n').map((question, index) =>
                                                <div key={index}>{question}</div>
                                            )}</p>
                                        </Alert>
                                    )}

                                    <AdditionalQuestions
                                        additionalQuestions={additionalQuestions}
                                        onChangeQuestion={this.handleChangeQuestion}
                                        onChangeAnswer={this.handleChangeAnswer}
                                        onRemoveQuestion={this.handleRemoveQuestion}
                                        onAddQuestion={this.handleAddQuestion}
                                    />
                                </Panel.Body>
                                {this.state.originalAdditionalQuestions && (
                                    <Panel.Footer>
                                        Previously, the additional questions were just freeform text, but going forward each question/answer combination will be saved individually.<br />
                                        The <Badge style={{ color: '#31708f', backgroundColor: '#d9edf7', borderColor: '#bce8f1' }}>Original Questions</Badge> above are presented as entered.
                                    </Panel.Footer>
                                )}
                            </Panel>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={12}>
                            <Panel>
                                <Panel.Heading><b>Root Cause Classification</b></Panel.Heading>
                                <Panel.Body>
                                    <Row>
                                        <Col xs={6} lg={6}>
                                            <div>
                                                <FormGroup>
                                                    <ControlLabel>Primary</ControlLabel>
                                                    <FormControl
                                                        componentClass="select"
                                                        name="rootCausePrimaryId"
                                                        value={rootCausePrimaryId}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        {this.props.rccap.lookupData.causes.map((cause, index) =>
                                                            <option key={index} value={cause.id}>{cause.description}</option>
                                                        )}
                                                    </FormControl>
                                                </FormGroup>
                                            </div>

                                            <div>
                                                <FormGroup>
                                                    <ControlLabel>Secondary</ControlLabel>
                                                    <FormControl
                                                        componentClass="select"
                                                        name="rootCauseSecondaryId"
                                                        value={rootCauseSecondaryId}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        {secondaryCauseList.map((cause, index) =>
                                                            <option key={index} value={cause.id}>{cause.description}</option>
                                                        )}
                                                    </FormControl>
                                                </FormGroup>
                                            </div>
                                        </Col>
                                        <Col xs={6} lg={6}>
                                            <div>
                                                <FormGroup>
                                                    <ControlLabel>Avoidable</ControlLabel>
                                                    <FormControl
                                                        componentClass="select"
                                                        name="rccapAvoidable"
                                                        value={rccapAvoidable}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        {this.props.rccap.lookupData.avoidable.map((item, index) =>
                                                            <option key={index} value={item.id}>{item.description}</option>
                                                        )}
                                                    </FormControl>
                                                </FormGroup>
                                            </div>

                                            <div>
                                                <FormGroup>
                                                    <ControlLabel>If Avoidable, Billable?</ControlLabel>
                                                    <FormControl
                                                        componentClass="select"
                                                        name="rccapBillable"
                                                        value={rccapBillable}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        {this.props.rccap.lookupData.billable.map((item, index) =>
                                                            <option key={index} value={item.id}>{item.description}</option>
                                                        )}
                                                    </FormControl>
                                                </FormGroup>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs={12} lg={12}>
                                            <div>
                                                <FormGroup>
                                                    <ControlLabel>Satisfactory Response</ControlLabel>
                                                    <FormControl
                                                        componentClass="select"
                                                        name="rccapSatisfactoryResponse"
                                                        value={rccapSatisfactoryResponse}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        {this.props.rccap.lookupData.satisfactoryResponses.map((item, index) =>
                                                            <option key={index} value={item.id}>{item.description}</option>
                                                        )}
                                                    </FormControl>
                                                </FormGroup>
                                            </div>

                                            <div>
                                                <FormGroup>
                                                    <ControlLabel>Accepted Response</ControlLabel>
                                                    <FormControl
                                                        componentClass="textarea"
                                                        name="acceptedResponse"
                                                        value={acceptedResponse}
                                                        placeholder="..."
                                                        style={{ height: 80, resize: "none" }}
                                                        onChange={this.handleTextChange}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>
                                    </Row>
                                </Panel.Body>
                            </Panel>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={12}>
                            <Panel>
                                <Panel.Heading><b>Corrective Action Plan</b></Panel.Heading>
                                <Panel.Body>
                                    <Row style={{ marginBottom: 0 }}>
                                        <Col xs={12} lg={12}>
                                            <div>
                                                <FormGroup>
                                                    <ControlLabel>Primary</ControlLabel>
                                                    <FormControl
                                                        componentClass="select"
                                                        name="correctiveActionPrimary"
                                                        value={correctiveActionPrimary}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        {this.props.rccap.lookupData.correctiveActions.map((cause, index) =>
                                                            <option key={index} value={cause.id}>{cause.description}</option>
                                                        )}
                                                    </FormControl>
                                                </FormGroup>
                                            </div>

                                            <div>
                                                <FormGroup>
                                                    <ControlLabel>Secondary</ControlLabel>
                                                    <FormControl
                                                        componentClass="select"
                                                        name="correctiveActionSecondary"
                                                        value={correctiveActionSecondary}
                                                        onChange={this.handleSelectChange}
                                                    >
                                                        {this.props.rccap.lookupData.correctiveActions.map((cause, index) =>
                                                            <option key={index} value={cause.id}>{cause.description}</option>
                                                        )}
                                                    </FormControl>
                                                </FormGroup>
                                            </div>

                                            <div>
                                                <FormGroup>
                                                    <ControlLabel>Additional Corrective Action Information</ControlLabel>
                                                    <FormControl
                                                        componentClass="textarea"
                                                        name="centerCorrectiveAction"
                                                        value={centerCorrectiveAction}
                                                        placeholder="..."
                                                        style={{ height: 80, resize: "none" }}
                                                        onChange={this.handleTextChange}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>
                                    </Row>
                                </Panel.Body>
                            </Panel>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={12}>
                            <Panel>
                                <Panel.Heading><b>RCCAP Response</b></Panel.Heading>
                                <Panel.Body>
                                    <Row>
                                        <Col xs={6} lg={6}>
                                            <FormGroup>
                                                <ControlLabel>Center Responder</ControlLabel>
                                                <FormControl
                                                    name="responder"
                                                    value={responder}
                                                    onChange={this.handleTextChange}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col xs={6} lg={6}>
                                            <FormGroup>
                                                <ControlLabel>Response Date</ControlLabel>
                                                {/* <DateTime
                                                    value={responseDate}
                                                    input={true}
                                                    dateFormat={"MM/DD/YY"}
                                                    timeFormat={false}
                                                    closeOnSelect={false}
                                                    inputProps={{ className: "form-control" }}
                                                    onChange={(value: moment.Moment) => this.handleDateChange('responseDate', value)}
                                                /> */}
                                                <MaskedInput
                                                    className='form-control'
                                                    mask='11/11/11'
                                                    placeholder='MM/DD/YY'
                                                    //style={{ borderColor: this.props.validDeadline ? '#ccc' : '#a94442' }}
                                                    value={responseDate}
                                                    onChange={this.handleResponseDateChange}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Panel.Body>
                            </Panel>
                        </Col>
                    </Row>
                </div>

                <Row>
                    <Col style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: 20 }}>
                        <ActionButtons size="medium" onSave={this.handleSave} onCancel={this.handleCancel} />
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        rccap: appState.rccap
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getLookupData: () => {
            return dispatch(RccapActionCreators.getRccapLookupData(false));
        },
        setLookupData: (lookupData) => {
            dispatch(RccapActionCreators.setRccapLookupData(lookupData));
        },
        getRccap: (id) => {
            return dispatch(RccapActionCreators.getRccap(id, false));
        },
        saveRccap: (request) => {
            return dispatch(RccapActionCreators.saveRccap(request));
        },
        getRccapDetails: (chainId, clusterNumber, positionNumber) => {
            return dispatch(SwapActionCreators.getRccapDetails(chainId, clusterNumber, positionNumber));
        }
    };
}

export default withRouter(connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(RccapAddEdit));